module.exports = __webpack_public_path__ + "static/media/img2.2ad8107f.png";